import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, Link } from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../utils/global'
import { escapeHtml } from '../../../utils/textFunctions'
import '../../../styles/assets/css/pages/form5.css'
import { loadLocationWithMessage } from '../../../actions/location'
import { cgi_type, cgi_mood, mood_state_long, mood_state_long_type,
  severity_illness, improvement } from '../variables/assessments/cgi_bd.js'

import WarningIcon from '@material-ui/icons/Warning'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import PatientHead3 from "../patient/patient_head3"

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogActions from '@material-ui/core/DialogActions'

class CgiBD extends Component {
  constructor() {
      super()
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          date: new Date(),
          rater: 0,
          rater_name: '',
          type: 0,
          appointment_id: 0,
          appt_list: [],
          selected_appt_id: 0,
          mood_initial: 0,
          mood_state_long: 0,
          mood_state_long_type: 0,
          severity_a: 0,
          severity_b: 0,
          severity_c: 0,
          severity_mixmood: 0,
          improvement_a: 0,
          improvement_b: 0,
          improvement_c: 0,
          anxiety_disorder: 0,
          behavioral_substance: 0,
          start_datetime: Math.floor(new Date().getTime()/1000),
          showNoAppointmentDialog: false,

      }
  }

  componentDidMount() {
    this.getAssmProcess()
  }

  getAssmProcess = async () => {
    const { pid, appt_id } = this.props.match.params;
    const { uid, role } = this.props.authReducer;

    const config = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
    };

    try {
      // Check permission
      const permissionRes = await axios.post(
        connectNode + 'admin/patient/check_permission_get_data',
        { pid,
          uid,
          user_role: role, },
        config
      );

      if ( !Array.isArray(permissionRes.data) || permissionRes.data.length === 0 ) {
        this.props.history.push('/admin/patient_list');
        return;
      }


      // Get clinician name
      let arr_send = { cid: uid, pid };
      if (appt_id > 0) {
        arr_send = {
          cid: uid,
          appt_id,
          pid,
        };
      }

      const clinicianRes = await axios.post(
        connectNode + 'patient/general/get_clinician_appt',
        arr_send,
        config
      );

      //console.log(clinicianRes)

      const apptDate = clinicianRes.data?.[1]?.value.appt_date;

      this.setState({
        rater: uid,
        rater_name: clinicianRes.data?.[0]?.value.fullname || '',
        date: apptDate ? new Date(apptDate + 'T00:00:00') : new Date(),
        appointment_id: appt_id || null,
        appt_list: clinicianRes.data?.[2]?.value
      });

    } catch (error) {
      console.error('getAssmProcess error:', error);
      this.props.history.push('/admin/patient_list');
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  handleDateChange = (e, name) => {
    this.setState({ [name]: e })
  }

  checkOverOneMonth = (appt_date) => {
    const isOverOneMonth = appt_date && new Date() > new Date(new Date(appt_date).setMonth(new Date(appt_date).getMonth() + 1));
    //console.log(appt_date + ' > ' + isOverOneMonth)
    return isOverOneMonth ? '(Over 1 month)' : ''
  }


  handleSubmit = (e) => {
    e.preventDefault()

    const {
      type,
      date,
      severity_mixmood,
      severity_a,
      severity_b,
      severity_c,
      anxiety_disorder,
      behavioral_substance,
      selected_appt_id,
      appointment_id,
    } = this.state

    if (
      type === 0 ||
      date === '' ||
      severity_mixmood === 0 ||
      severity_a === 0 ||
      severity_b === 0 ||
      severity_c === 0 ||
      anxiety_disorder === 0 ||
      behavioral_substance === 0
    ) {
      this.setState({
        message: 'Please complete all items',
      })

      window.scrollTo(0, 0)
      return
    }

    if (!selected_appt_id && !appointment_id) {
      this.setState({
        showNoAppointmentDialog: true,
      })
      return
    }

    this.submitCgiBD()
  }

  submitCgiBD = () => {
    const { pid, appt_id } = this.props.match.params

    this.setState({
      status_submit: false,
      message: '',
      showNoAppointmentDialog: false,
    })

    axios({
      method: 'post',
      url: connectNode + 'admin/assessment/add_cgi_bd',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: {
        cid: this.props.authReducer.uid,
        user: this.state,
        pid,
      },
    }).then((result) => {
      if (result.data === pid) {
        let url = `/admin/patient_chart/${pid}/5/4`

        if (appt_id > 0) {
          url = `/admin/patient_chart/${pid}/1/1`
        }

        this.props.onLoadLocation(
          url,
          'New CGI-BD added successfully!'
        )
        this.props.history.push(url)
      }
    })
  }

  render() {

    return (
      <div className="assm_mini box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Clinical Global Impressions – Bipolar Disorder (CGI-BD)
          </div>
        </div>
        <PatientHead3 />
        { this.state.message !== '' &&
        <div className="row warning_msg6 top_space2">
          <div className="small-12 columns ">
            <div className="float_left1"><WarningIcon /></div>
            <div className="txt_warning_msg1">{ this.state.message }</div>
          </div>
        </div>}
        { (this.props.authReducer.role == 3 || this.props.authReducer.role == 6) &&
          <form onSubmit={this.handleSubmit}>
          <div className="row top_space2">
            <div className="small-12 columns box1">
              <div className="row">
                <div className="small-12 medium-3 columns top_space2 text_align_right">
                  <span className="bold">Rater:</span>
                </div>
                <div className="small-12 medium-9 columns top_space2">
                   {this.state.rater_name}
                </div>
                <div className="small-12 medium-3 columns top_space2 text_align_right">
                  <span className="bold">Date:</span>
                </div>
                <div className="small-12 medium-9 columns top_space2">
                  <DatePicker selected={this.state.date} maxDate={new Date()}
                  onChange={(e) => this.handleDateChange(e, 'date')}
                  className="date_picker short2" disabled={Number(this.props.match.params.appt_id) > 0} />
                </div>
                {this.props.match.params.appt_id == null && <>
                <div className="small-12 medium-3 columns top_space2 text_align_right">
                  <span className="bold">Appointment Date:</span>
                </div>
                <div className="small-12 medium-5 columns top_space2 float_left">
                  <FormControl variant="outlined">
                    <Select value={this.state.selected_appt_date} variant="outlined" name="selected_appt_id"
                      label="" onChange={this.handleChange}>
                      {this.state.appt_list.map( each =>
                        <MenuItem key={'appt_'+each.id} value={each.id}>{each.formatted_date} {this.checkOverOneMonth(each.formatted_date)}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
                </>}
                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>
                <div className="small-12 columns">
                {cgi_type.map(each =>
                  <div className="each_choice1" key={'type'+each.label}>
                    <input type="radio" name="type" value={each.value} onChange={(e) => this.handleChange(e)}/>
                    <span>{each.label}</span>
                  </div>
                )}
                </div>
                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>
                <div className="small-12 columns">
                  <div className="bold">1. Severity of Illness: Bipolar Disorder</div>
                  <div>Considering your total clinical experience with bipolar patients, how severely ill has the patient been during the past week?</div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-12 medium-3 columns top_space2">a. Mania</div>
                    <div className="small-12 medium-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.severity_a} variant="outlined" name="severity_a"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'sa'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-12 medium-3 columns top_space2">b. Depression</div>
                    <div className="small-12 medium-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.severity_b} variant="outlined" name="severity_b"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'sb'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-12 medium-3 columns top_space2">c. Mixed mood state</div>
                    <div className="small-12 medium-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.severity_mixmood} variant="outlined" name="severity_mixmood"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'sb'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-12 medium-3 columns top_space2">d. Overall Bipolar Illness</div>
                    <div className="small-12 medium-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.severity_c} variant="outlined" name="severity_c"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'sc'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>

                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>
                <div className="small-12 columns">
                  <div className="bold">2. Severity of Illness: Anxiety Disorder</div>
                  <div>Considering your total clinical experience with anxiety disorder patients, how severely ill has the patient been during the past week?</div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.anxiety_disorder} variant="outlined" name="anxiety_disorder"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'ia'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>

                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>
                <div className="small-12 columns">
                  <div className="bold">3. Severity of Illness: Behavioral and Substance Use Disorder</div>
                  <div>Considering your total clinical experience with behavioral and substance use disorder patients, how severely ill has the patient been during the past week?</div>
                </div>
                <div className="small-12 columns top_space2">
                  <div className="row">
                    <div className="small-6 columns float_left">
                    <FormControl variant="outlined">
                      <Select value={this.state.behavioral_substance} variant="outlined" name="behavioral_substance"
                        label="" onChange={(e) => this.handleChange(e)}>
                        {severity_illness.map( each =>
                          <MenuItem key={'ia'+each.value} value={each.value}>{each.label}</MenuItem>
                        )}
                      </Select>
                    </FormControl>
                    </div>
                  </div>
                </div>

                <div className="small-12 columns">
                  <div className="sep_line2">&nbsp;</div>
                </div>
                <div className="small-12 columns">
                  <div className="bold">Severity scale for all items: </div>
                  <div className="top_space2">1 = Normal—not at all ill, symptoms of disorder not present past seven days</div>
                  <div>2 = Borderline mentally ill—subtle or suspected pathology</div>
                  <div>3 = Mildly ill—clearly established symptoms with minimal, if any, distress or difficulty in social and occupational function</div>
                  <div>4 = Moderately ill—overt symptoms causing noticeable, but modest, functional impairment or distress; symptom level may warrant medication</div>
                  <div>5 = Markedly ill—intrusive symptoms that distinctly impair social/occupational function or cause intrusive levels of distress</div>
                  <div>6 = Severely ill—disruptive pathology, behavior and function are frequently influenced by symptoms, may require assistance from others</div>
                  <div>7 = Among the most extremely ill patients—pathology drastically interferes in many life functions; may be hospitalized</div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="small-12 medium-6 columns">
              <Link to={"/admin/patient_chart/"+this.props.match.params.pid+"/3/3"}
              className="go_back">Go Back</Link>
            </div>
            <div className="small-12 medium-6 columns align_right">
            {!this.state.status_submit &&
              <Button variant="contained" color="primary" disabled
                 onClick={this.handleSubmit} type="submit" className="submit_1">
                  Submit
              </Button>}
            {this.state.status_submit &&
              <Button variant="contained" color="primary"
                 onClick={this.handleSubmit} type="submit" className="submit_1">
                  Submit
              </Button>}
            </div>
          </div>
        </form>
        }
      <Dialog
        open={this.state.showNoAppointmentDialog}
        onClose={() =>
          this.setState({ showNoAppointmentDialog: false })
        }
        aria-labelledby="no-appointment-dialog-title"
      >
        <DialogTitle id="no-appointment-dialog-title">
          No Appointment Selected
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            This CGI-BD is not connected to an appointment.
            Are you sure you want to continue?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
  <Button
    onClick={() =>
      this.setState({ showNoAppointmentDialog: false })
    }
    color="primary"
    variant="contained"
  >
    Cancel
  </Button>

  <Button
    onClick={this.submitCgiBD}
    color="primary"
    variant="contained"
    autoFocus
  >
    Continue
  </Button>
</DialogActions>
      </Dialog>
    </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CgiBD)
